import React from "react";
import { RecIcon, RecThumb } from "./MaterialRecordParts";
import { formatCost, hasLoadedField, isServiceType, materialTypeLabel } from "./materialRecordModel";

/**
 * One catalog row. Normal mode: tap opens Details, no checkbox column.
 * Selection mode: a leading check control appears and tapping toggles it.
 */
export function MaterialRow({
  material,
  canViewPricing,
  selecting = false,
  selected = false,
  onToggle,
  onOpen,
  imageUrl,
}) {
  const service = isServiceType(material.material_type);
  const cost =
    canViewPricing && hasLoadedField(material, "unit_cost") ? formatCost(material) : null;
  const unit = material.unit_of_measure || "";
  const inactive = material.active === false;

  const handleClick = () => (selecting ? onToggle?.() : onOpen?.(material));

  return (
    <button
      type="button"
      className={`mat-row${selected ? " is-selected" : ""}${inactive ? " is-inactive" : ""}`}
      onClick={handleClick}
      role={selecting ? "checkbox" : undefined}
      aria-checked={selecting ? selected : undefined}
      aria-label={selecting ? `Select ${material.material_name}` : undefined}
    >
      {selecting ? (
        <span className="mat-row__check" aria-hidden="true">
          <RecIcon name="check" />
        </span>
      ) : null}
      <RecThumb
        name={material.material_name}
        type={material.material_type}
        imageUrl={imageUrl}
        size="list"
      />
      <span className="mat-row__main">
        <span className="mat-row__name">{material.material_name}</span>
        <span className="mat-row__sku">{material.sku || "No SKU"}</span>
        {unit || service ? (
          <span className="mat-row__unit">
            <RecIcon name={service ? "wrench" : "cube"} />
            {service ? `${materialTypeLabel(material.material_type)}${unit ? ` · ${unit}` : ""}` : unit}
          </span>
        ) : null}
      </span>
      {cost ? (
        <span className={`mat-row__cost${cost === "—" ? " is-none" : ""}`}>{cost}</span>
      ) : null}
    </button>
  );
}
